import './env';
import 'react-notifications/lib/notifications.css';

import { Route } from 'react-router-dom';
import { Box, Typography } from "@material-ui/core";
import React from 'react';
import { useSelector } from 'react-redux';
import { Admin, Resource, Layout, AppBar, SearchInput, SimpleForm, TextInput, List, usePermissions } from 'react-admin';
import { NotificationContainer } from 'react-notifications';
import { PublisherList, PublisherEdit, PublisherCreate } from './publishers';
// import { NetworkList, NetworkEdit, NetworkCreate } from './networks'
import { AdvertiserList, AdvertiserEdit, AdvertiserCreate } from './advertisers';
import { SiteList, SiteEdit, SiteCreate } from './sites';
import { ShareEntityCreate, ShareEntityEdit } from './share';
import { SiteBatchCreate, SiteBatchEdit } from './batch_site';
import { PlacementBatchCreate, PlacementBatchEdit } from './batch_placement';
import { PlacementList, PlacementEdit, PlacementCreate } from './placements';
import { OrderList, OrderEdit } from './orders';
import { LineItemList } from './line_items';
import { ExperimentList, ExperimentEdit, ExperimentCreate } from './experiments';
import { SegmentList, SegmentEdit, SegmentCreate } from './segments';
import { ClicksList, ClicksCreate, ClicksEdit } from './clicks';
import { AuctionsList, AuctionsCreate, AuctionsEdit } from './auctions';
import { DiscrepanciesList, DiscrepanciesCreate, DiscrepanciesEdit } from './discrepancies';
import { AuctionOptimizerReportList, AuctionOptimizerReportEdit, AuctionOptimizerReportCreate } from './auction_optimizer';
import { AdViewabilityReportList, AdViewabilityReportCreate, AdViewabilityReportEdit } from './ad_viewability';
import { AdDomainsReportList, AdDomainsReportCreate, AdDomainsReportEdit } from './ad_domains';
import { SecretsList, SecretsCreate, SecretsEdit } from './secrets';
import { AdstxtReportList, AdstxtReportCreate, AdstxtReportEdit } from './adstxtreports';
import { AdQualityReportsList, AdQualityReportsCreate, AdQualityReportsEdit } from './adquality_reports';
import { AdMalwareReportList, AdMalwareReportCreate, AdMalwareReportEdit } from './ad_malware';
import { SegmentReportsList, SegmentReportEdit, SegmentReportCreate } from './segment_reports';
import { UserList, UserEdit, UserCreate } from './users';
import { DomainList, DomainCreate, DomainEdit } from './domains';
import { AdvertiserDomainList, AdvertiserDomainCreate, AdvertiserDomainEdit } from './advertiser_domains';
import { MissingSitesList, MissingSitesCreate, MissingSitesEdit } from './missing_sites';
import { DomainBatchCreate, DomainBatchEdit } from './batch_domain';
import { AlarmList, AlarmShow } from './alarms';
// import { AdstxtList } from './adstxt';
import { AdServingCostList } from './adcost';
import { IVTList } from './ivt';
// import { IVTDomainList } from './ivt_domains';
import { RealtimeDashboardList, RealtimeDashboardCreate, RealtimeDashboardEdit } from './realtime';
import { TopSitesList } from './topsites';
import { PublisherEarningReportList, PublisherEarningReportEdit, PublisherEarningReportCreate } from './pubreports';
import { CarbonPublisherEarningReportList, CarbonPublisherEarningReportEdit, CarbonPublisherEarningReportCreate } from './carbon/pubreports';
import { CarbonDiscrepanciesList, CarbonDiscrepanciesEdit, CarbonDiscrepanciesCreate } from './carbon/discrepancies';
import { CarbonizerReportList, CarbonizerReportEdit, CarbonizerReportCreate } from './carbon/carbonizer';
import { CarbonRealtimeReportList, CarbonRealtimeReportEdit, CarbonRealtimeReportCreate } from './carbon/realtime';
// import { CarbonCalculator } from './carbon/calculator';
import CarbonDashboard from './carbon/dashboard';
import { CarbonSettings } from './carbon/settings';
import { CampaignList, CampaignEdit, CampaignCreate } from './campaigns';
import { AdQualityRuleList, AdQualityRuleEdit, AdQualityRuleCreate } from './ad_quality_rules';
import { DealList, DealEdit, DealCreate } from './deals';
import { AdCampaignList, AdCampaignEdit, AdCampaignCreate } from './adcampaigns';
import { CreativeList, CreativeEdit, CreativeCreate } from './creatives';
// import { ClusterList } from './cluster';
import { BidderList, BidderEdit } from './bidders';
import { SettingsList, SettingsEdit } from './settings';
import { PredictionsList } from './predictions';
import { LogsList } from './logbook';
import { GamAccountList, GamAccountCreate, GamAccountEdit } from './gam_accounts';
import Dashboard from './Dashboard/Dashboard';
import authProvider from './authProvider';
import { createTheme } from '@material-ui/core/styles';
import { AccountTree, AccountCircle, AccountBalance, BarChart, FilterTiltShift, Share, Lock, Language,
  BrandingWatermark, Description, Settings, MenuBook, PhotoLibrary, ShoppingCart, FindInPage, AddShoppingCart, 
  LocalMall, Business, MonetizationOn, Traffic, Public, AlarmOn, BuildRounded, LocalShipping, ViewList, CallSplit, Speed }
  from '@material-ui/icons';
import EcoSharpIcon from '@material-ui/icons/EcoSharp';
import pink from '@material-ui/core/colors/pink';
import dataProvider from './dataprovider';
import TreeMenu from '@bb-tech/ra-treemenu';
import { GlobalSearchInput } from './global_search';
import { NotificationsComponent } from './notifications';
import { LoginPage, LoginPasswordForgot, LoginPasswordReset } from './LoginPage';

const roles = require('./components/roles.json');

const theme = createTheme({
  palette: {
    type: 'dark',
    primary: pink,
    secondary: pink,
  },
  status: {
    danger: 'orange',
  },
  typography: {
    fontSize: 12
  },
  spacing: 6,
  props: {
  //   MuiButton: {
  //     size: 'small',
  //   },
  //   MuiFilledInput: {
  //     margin: 'dense',
  //   },
  //   MuiFormControl: {
  //     margin: 'dense',
  //   },
  //   MuiFormHelperText: {
  //     margin: 'dense',
  //   },
  //   MuiIconButton: {
  //     size: 'small',
  //   },
  //   MuiInputBase: {
  //     margin: 'dense',
  //   },
  //   MuiInputLabel: {
  //     margin: 'dense',
  //   },
    MuiListItem: {
      dense: true,
    },
  //   MuiOutlinedInput: {
  //     margin: 'dense',
  //   },
  //   MuiFab: {
  //     size: 'small',
  //   },
  //   MuiTable: {
  //     size: 'small',
  //   },
  //   MuiTextField: {
  //     margin: 'dense',
  //   },
  //   MuiToolbar: {
  //     variant: 'dense',
  //   },
  },
  overrides: {
    RaList: {
      root: {
        marginTop: '30px'
      }
    }
  }
});

function readFileAsDataURL(file) {
  let result_base64 = new Promise((resolve, reject) => {
    let fileReader = new FileReader();
    fileReader.onload = () => resolve(fileReader.result);
    fileReader.onerror = reject;
    fileReader.readAsDataURL(file.rawFile);
  });
  return result_base64;
}
const nobidDataProvider = {
  ...dataProvider
  , getList: (resource, params) => {
    if (params.filter && params.filter.batch_file && params.filter.batch_file.rawFile) {
      let file = params.filter.batch_file.rawFile
      let resultBase64 = readFileAsDataURL(file.rawFile)
      return dataProvider.getList(resource, {
        ...params,
        data: {
          ...params.data,
          file_data: resultBase64
        }
      });
    } else {
      return dataProvider.getList(resource, params)
    }
  }
  , create: (resource, params) => {
    if (resource === 'creatives' && params.data && params.data.image) {
      params.data.image = [params.data.image];
      const newPictures = params.data.image.filter(
        p => p.rawFile instanceof File
      );

      if (!newPictures || newPictures.length <= 0) {
        delete params.image;
        return dataProvider.create(resource, params);
      }
      return Promise.all(newPictures.map(readFileAsDataURL))
        .then(base64Pictures =>
          base64Pictures.map(picture64 => ({
            src: picture64
          }))
        )
        .then(transformedNewPictures =>
          dataProvider.create(resource,
            { ...params, data: { ...params.data, file_data: transformedNewPictures[0] } }
          )
        );
    } else {
      return dataProvider.create(resource, params);
    }
  }
  , update: (resource, params) => {
    // console.log('### update resource: '+resource);
    // console.log('### update params: '+JSON.stringify(params));
    if (resource == 'creatives' && params.data && params.data.image) {
      params.data.image = Array.isArray(params.data.image) ? params.data.image : [params.data.image];
      const newPictures = params.data.image.filter(
        p => p.rawFile instanceof File
      );

      if (!newPictures || newPictures.length <= 0) {
        delete params.image;
        return dataProvider.update(resource, params);
      }
      return Promise.all(newPictures.map(readFileAsDataURL))
        .then(base64Pictures =>
          base64Pictures.map(picture64 => ({
            src: picture64
          }))
        )
        .then(transformedNewPictures =>
          dataProvider.update(resource,
            { ...params, data: { ...params.data, file_data: transformedNewPictures[0] } }
          )
        );
    } else {
      return dataProvider.update(resource, params);
    }
  }
};

function isAuthorized (permissions, resourceId) {
  const { role, resources } = permissions;
  if (resources && resources.length > 0) {
    return resources.includes(resourceId) || roles[role].defaultResources.includes(resourceId);
  } else if (roles[role]) {
    return roles[role].defaultResources.includes(resourceId);
  } else {
    return false;
  }
}

function apiResources (permissions) {
  return roles["api"].defaultResources.map( r => !isAuthorized (permissions, r) ? <Resource name={`${r}`} /> : null)
    .filter( rComponenet => rComponenet !== null );
}
function localTime() {
  const e = document.getElementById('localTime');
  if (e) {
     e.innerHTML = Intl.DateTimeFormat(navigator.languages, {timeStyle: 'medium', dateStyle: 'medium'}).format(new Date());
  }
  setTimeout(localTime, 1000);
}
localTime();
const MyAppBar = (props) => {
  const { permissions } = usePermissions();
  const loading = useSelector((state) => state.admin.loading);
  return(
  <AppBar {...props}>
    <Box flex="1">
      <Typography id="react-admin-title"></Typography>
    </Box>
    <Box flex="1" style={{textAlign: 'right'}}>
      <Typography style={{fontFamily: 'sans-serif'}}><span id='localTime'></span></Typography>
    </Box>
    <GlobalSearchInput/>
    { permissions?.role === 'admin' && <NotificationsComponent loading={loading}/> }
  </AppBar>
)};
const MyLayout = (props) => <Layout {...props} appBar={MyAppBar} />;

const App = () => (
  <Admin
    title="NoBid Insights"
    theme={theme}
    dashboard={Dashboard}
    loginPage={LoginPage}
    customRoutes={[
      <Route exact path="/loginPasswordForgot" component={LoginPasswordForgot} noLayout/>,
      <Route exact path="/loginPasswordReset" component={LoginPasswordReset} noLayout/>
    ]}
    authProvider={authProvider}
    dataProvider={nobidDataProvider}
    menu={TreeMenu}
    layout={MyLayout}
  >
    {permissions => [
      isAuthorized(permissions, 'inventory') ? <Resource name="inventory" options={{ label: "> Inventory", isMenuParent: true }} icon={Business}/> : null,
      // isAuthorized(permissions, 'networks') ? <Resource name="networks" list={NetworkList} edit={NetworkEdit} create={NetworkCreate} icon={AccountBox} options={{ menuParent: "inventory"}} /> : null,
      isAuthorized(permissions, 'publishers') ? <Resource name="publishers" list={PublisherList} edit={PublisherEdit} create={(permissions.role === 'admin')? PublisherCreate:null} icon={AccountBalance} options={{ menuParent: "inventory"}} /> : null,
      isAuthorized(permissions, 'sites') ? <Resource name="sites" list={SiteList} edit={SiteEdit} create={(permissions.role === 'admin')?SiteCreate:null} icon={Language} options={{ menuParent: "inventory"}} /> : null,
      isAuthorized(permissions, 'domains') ? <Resource name="domains" list={DomainList} edit={DomainEdit} create={DomainCreate} options={{ label: 'Domains', menuParent: "inventory" }} icon={Public} /> : null,
      isAuthorized(permissions, 'placements') ? <Resource name="placements" list={PlacementList} edit={PlacementEdit} create={PlacementCreate} icon={BrandingWatermark} options={{ menuParent: "inventory"}} /> : null,
      isAuthorized(permissions, 'batch') ? <Resource name="batch" list={SiteBatchCreate} edit={SiteBatchEdit} options={{ label: 'Batch Sites', menuParent: "inventory" }} icon={Description} /> : null,
      isAuthorized(permissions, 'batchp') ? <Resource name="batchp" list={PlacementBatchCreate} edit={PlacementBatchEdit} options={{ label: 'Batch Placements', menuParent: "inventory" }} icon={Description} /> : null,
      isAuthorized(permissions, 'batchd') ? <Resource name="batchd" list={DomainBatchCreate} edit={DomainBatchEdit} options={{ label: 'Batch Domains', menuParent: "inventory" }} icon={Description} /> : null,
      isAuthorized(permissions, 'gam_accounts') ? <Resource name="gam_accounts" list={GamAccountList} edit={GamAccountEdit} create={GamAccountCreate} icon={AccountTree} options={{menuParent: 'inventory' }} /> : null,
      isAuthorized(permissions, 'delivery') ? <Resource name="delivery" options={{ label: "> Delivery", isMenuParent: true }} icon={LocalShipping}/> : null,
      isAuthorized(permissions, 'bidders') ? <Resource name="bidders" list={BidderList} edit={BidderEdit} options={{ label: 'Bidders', menuParent: 'delivery' }} icon={MonetizationOn} /> : null,
      isAuthorized(permissions, 'campaigns') ? <Resource name="campaigns" list={CampaignList} edit={CampaignEdit} create={CampaignCreate} options={{ label: 'Traffic Rules', menuParent: 'delivery' }} icon={Traffic} /> : null,
      isAuthorized(permissions, 'ad_quality_rules') ? <Resource name="ad_quality_rules" list={AdQualityRuleList} edit={AdQualityRuleEdit} create={AdQualityRuleCreate} options={{ label: 'Ad Quality Rules', menuParent: 'delivery'}} icon={FilterTiltShift} /> : null,
      isAuthorized(permissions, 'adcampaigns') ? <Resource name="adcampaigns" list={AdCampaignList} edit={AdCampaignEdit} create={AdCampaignCreate} options={{ label: 'Campaigns', menuParent: 'delivery' }} icon={ShoppingCart} /> : null,
      isAuthorized(permissions, 'creatives') ? <Resource name="creatives" list={CreativeList} edit={CreativeEdit} create={CreativeCreate} options={{ label: 'Creatives', menuParent: 'delivery' }} icon={PhotoLibrary} /> : null,
      isAuthorized(permissions, 'segments') ? <Resource name="segments" list={SegmentList} edit={SegmentEdit} create={SegmentCreate} options={{ label: 'Segments', menuParent: 'delivery' }} icon={FindInPage} /> : null,
      isAuthorized(permissions, 'advertiser_domains') ? <Resource name="advertiser_domains" list={AdvertiserDomainList} edit={AdvertiserDomainEdit} create={AdvertiserDomainCreate} options={{ label: 'Advertiser Domains', menuParent: "delivery" }} icon={Public} /> : null,
      isAuthorized(permissions, 'deals') ? <Resource name="deals" list={DealList} edit={DealEdit} create={DealCreate} options={{ label: 'Deals', menuParent: 'delivery' }} icon={LocalMall} /> : null,
      isAuthorized(permissions, 'advertisers') ? <Resource name="advertisers" list={AdvertiserList} edit={AdvertiserEdit} create={(permissions.role === 'admin')?AdvertiserCreate:null} options={{menuParent: 'delivery' }} icon={AccountBalance} /> : null,
      isAuthorized(permissions, 'experiments') ? <Resource name="experiments" list={ExperimentList} edit={ExperimentEdit} create={ExperimentCreate} options={{menuParent: 'delivery' }} icon={CallSplit} /> : null,
      isAuthorized(permissions, 'orders') ? <Resource name="orders" list={OrderList} edit={(permissions.role === 'admin')?OrderEdit:null} icon={AddShoppingCart} options={{ menuParent: "delivery"}} /> : null,
      isAuthorized(permissions, 'line_items') ? <Resource name="line_items" list={LineItemList} icon={ViewList} options={{ menuParent: "delivery"}} /> : null,
      // isAuthorized(permissions, 'adstxtstatus') ? <Resource name="adstxtstatus" list={AdstxtList} options={{ label: 'Ads.txt' }} icon={PlaylistAddCheck} /> : null,
      // (['admin', 'network_manager', 'publisher'].includes(role)) ? <Resource name="ivt_domains" list={IVTDomainList} options={{ label: 'IVT Domains' }} icon={ReportOff} /> : null,
      <Resource name="reports" options={{ label: "> Reports", isMenuParent: true }} icon={BarChart}/>,
      isAuthorized(permissions, 'predictions') ? <Resource name="predictions" list={PredictionsList} options={{ label: 'Bid Predictions', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'ivt') ? <Resource name="ivt" list={IVTList} options={{ label: 'IVT', menuParent: "reports"}} icon={BarChart} /> : null,
      isAuthorized(permissions, 'adcost') ? <Resource name="adcost" list={AdServingCostList} options={{ label: 'Ad Requests', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'topsites') ? <Resource name="topsites" list={TopSitesList} options={{ label: 'Market Movers', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'realtime') ? <Resource name="realtime" list={RealtimeDashboardList} edit={RealtimeDashboardEdit} create={RealtimeDashboardCreate} options={{ label: 'Realtime Dash', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'pubreports') ? <Resource name="pubreports" list={PublisherEarningReportList} edit={PublisherEarningReportEdit} create={PublisherEarningReportCreate} options={{ label: (permissions.role === 'advertiser')?'Activity Report':'Earning Reports', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'clicks') ? <Resource name="clicks" list={ClicksList} edit={ClicksEdit} create={ClicksCreate} options={{ label: 'Click Reports', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'auctions') ? <Resource name="auctions" list={AuctionsList} edit={AuctionsEdit} create={AuctionsCreate} options={{ label: 'Auction Reports', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'auction_optimizer') ? <Resource name="auction_optimizer" list={AuctionOptimizerReportList} create={AuctionOptimizerReportCreate} edit={AuctionOptimizerReportEdit} options={{ label: 'Optimizer', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'discrepancies') ? <Resource name="discrepancies" list={DiscrepanciesList} edit={DiscrepanciesEdit} create={DiscrepanciesCreate} options={{ label: 'Discrepancy', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'adViewability') ? <Resource name="adViewability" list={AdViewabilityReportList} edit={AdViewabilityReportEdit} create={AdViewabilityReportCreate} options={{ label: 'Viewability', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'ad_domains') ? <Resource name="ad_domains" list={AdDomainsReportList} edit={AdDomainsReportEdit} create={AdDomainsReportCreate} options={{ label: 'Ad Domains', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'missing_sites') ? <Resource name="missing_sites" list={MissingSitesList} edit={MissingSitesEdit} create={MissingSitesCreate} options={{ label: 'Missing Sites', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'ad_malware') ? <Resource name="ad_malware" list={AdMalwareReportList} edit={AdMalwareReportEdit} create={AdMalwareReportCreate} options={{ label: 'Ad Malware', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'adstxtreports') ? <Resource name="adstxtreports" list={AdstxtReportList} edit={AdstxtReportEdit} create={AdstxtReportCreate} options={{ label: 'Adstxt Coverage', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'adquality_reports') ? <Resource name="adquality_reports" list={AdQualityReportsList} edit={AdQualityReportsEdit} create={AdQualityReportsCreate} options={{ label: 'Ad Quality Reports', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'segmentreports') ? <Resource name="segmentreports" list={SegmentReportsList} edit={SegmentReportEdit} create={SegmentReportCreate} options={{ label: 'Segments', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'carbon/dashboard') ? <Resource name="carbon/dashboard" list={CarbonDashboard} edit={CarbonDashboard} create={CarbonDashboard} options={{ label: 'Dashboard', menuParent: "carbon" }} icon={Speed} /> : null,
      isAuthorized(permissions, 'carbon/pubreports') ? <Resource name="carbon/pubreports" list={CarbonPublisherEarningReportList} edit={CarbonPublisherEarningReportEdit} create={CarbonPublisherEarningReportCreate} options={{ label: 'Reports', menuParent: "carbon" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'carbon/discrepancies') ? <Resource name="carbon/discrepancies" list={CarbonDiscrepanciesList} edit={CarbonDiscrepanciesEdit} create={CarbonDiscrepanciesCreate} options={{ label: 'Discrepancies', menuParent: "carbon" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'carbon/realtime') ? <Resource name="carbon/realtime" list={CarbonRealtimeReportList} edit={CarbonRealtimeReportEdit} create={CarbonRealtimeReportCreate} options={{ label: 'Realtime', menuParent: "carbon" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'carbon/carbonizer') ? <Resource name="carbon/carbonizer" list={CarbonizerReportList} edit={CarbonizerReportEdit} create={CarbonizerReportCreate} options={{ label: 'Optimizer', menuParent: "carbon" }} icon={BarChart} /> : null,
      // isAuthorized(permissions, 'carbon/calculator') ? <Resource name="carbon/calculator" list={CarbonCalculator} edit={CarbonCalculator} create={CarbonCalculator} options={{ label: 'Calculator', menuParent: "carbon" }} icon={Speed} /> : null,
      isAuthorized(permissions, 'carbon/settings') ? <Resource name="carbon/settings" list={CarbonSettings} edit={CarbonSettings} create={CarbonSettings} options={{ label: 'Settings', menuParent: "carbon" }} icon={Settings} /> : null,
      isAuthorized(permissions, 'carbon') ? <Resource name="carbon" options={{ label: "> Analytics Adapter", isMenuParent: true }} icon={EcoSharpIcon}/> : null,
      permissions && permissions.role==='admin' ? <Resource name="admin" options={{ label: "> Admin", isMenuParent: true }} icon={BuildRounded}/> : null,
      isAuthorized(permissions, 'users') ? <Resource name="users" options={{ label: 'Users', menuParent: "admin" }} list={UserList} edit={UserEdit} create={UserCreate} icon={AccountCircle} /> : null,
      // (role === 'admin') ? <Resource name="cluster" options={{ label: 'Cluster' }} list={ClusterList} icon={Computer} /> : null,
      isAuthorized(permissions, 'logs') ? <Resource name="logs" list={LogsList} options={{ label: 'Logbook', menuParent: "admin" }} icon={MenuBook} /> : null,
      isAuthorized(permissions, 'alarms') ? <Resource name="alarms" list={AlarmList} show={AlarmShow} options={{ label: 'Alarms', menuParent: "admin" }} icon={AlarmOn} /> : null,
      isAuthorized(permissions, 'share') ? <Resource name="share" list={ShareEntityCreate} edit={ShareEntityEdit} options={{ label: 'Share', menuParent: "admin" }} icon={Share} /> : null,
      isAuthorized(permissions, 'secrets') ? <Resource name="secrets" list={SecretsList} create={SecretsCreate} edit={SecretsEdit} options={{ label: 'Secrets', menuParent: "admin" }} icon={Lock} /> : null,
      isAuthorized(permissions, 'settings') ? <Resource name="settings" list={SettingsList} edit={SettingsEdit} options={{ label: 'Settings', menuParent: "admin" }} icon={Settings} /> : null,

      [...apiResources(permissions)],
      <NotificationContainer/>
    ]}

  </Admin>
);

export default App;